module.exports = __webpack_public_path__ + "media/bootstrap-icons/arrow-right-2bd46576.svg";